import { Switch, Route, useRouteMatch } from 'react-router-dom';

import ContactUsMessages from '@pages/contactUsMessages/contactUsMessages/ContactUsMessages';
import ContactUsMessageContainer from '@pages/contactUsMessages/contactUsMessage/ContactUsMessageContainer';

const ContactUsMessagesRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={path}>
                <ContactUsMessages />
            </Route>
            <Route exact path={`${path}/:id`}>
                <ContactUsMessageContainer />
            </Route>
            <Route exact path={`${path}/:id/:action`}>
                <ContactUsMessageContainer />
            </Route>
        </Switch>
    );
};

export default ContactUsMessagesRoutes;
